import React, {Suspense} from 'react';
import MutateSingleVoyage from "@containers/singleVoyage/mutateVoyage/MutateSingleVoyage";
import {IPositionSingleVoyage} from "@containers/singleVoyage/types/position";
import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";

interface IProps {
    initialPositions?: IPositionSingleVoyage[]
    initialPoints?: IWayPointCreationWithCorrectionsSingleVoyage[]
}


const CreateSingleVoyage = ({
                                initialPositions,
                                initialPoints,
                            }: IProps) => {
    return (
        <Suspense
            fallback={<SpinnerCustom/>}
        >
            <MutateSingleVoyage
                initialPositions={initialPositions}
                initialPoints={initialPoints}
            />
        </Suspense>
    )

};

export default CreateSingleVoyage;
